import styled from "styled-components";

export const StudioModifierUnderlineContainer = styled.div`
  width: 100%;
  border-bottom: 2px solid rgba(232, 232, 232, 1);
  margin-top: 37px;
`;
